import { withTag, type AdPlatform } from "./types";

// Installed by `loadGoogleAds()` in marketing.js, which defines gtag as a
// synchronous `dataLayer.push` shim so early calls are queued.
type Gtag = (
  command: "event",
  eventName: "conversion",
  params: { send_to: string }
) => void;

declare global {
  interface Window {
    gtag?: Gtag;
  }
}

/**
 * Google Ads. Conversion tokens are Ads account labels, which are only
 * meaningful paired with the account id, hence the combined `send_to`.
 */
export const googleAds: AdPlatform = {
  name: "Google Ads",
  key: "googleAds",
  accountIdKey: "ID_GOOGLE_ADS",
  send: withTag(
    () => window.gtag,
    (gtag, label, accountId) =>
      gtag("event", "conversion", { send_to: `${accountId}/${label}` })
  )
};
